import ModalTarget from './modal';

export { ModalTarget };
